import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

// Components
import DisputesHeaderDark from "../Components/DisputesHeaderDark";

import BlogPostLayout04 from "./Blogs/LayoutPage/BlogPostLayout04";

import DisputesFooter from "../Components/DisputesFooter";

function DecisionSummary() {
  const { caseid } = useParams();
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    getSummary();
  }, [caseid]);

  const getSummary = async () => {
    try {
      const response = await axios.get(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}summaries/${caseid}/`
      );

      setSummary(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="min-h-100">
        {summary && (
          <>
            <DisputesHeaderDark />
            <BlogPostLayout04 data={summary} />

            {/* Footer End */}
          </>
        )}
      </div>

      <DisputesFooter
        theme="dark"
        className="text-[#828282] bg-darkgray consulting-footer"
      />
    </>
  );
}

export default DecisionSummary;
